<div class="ocr-panel" aria-live="polite" aria-busy="true" role="status">
  <div class="ocr-doc" aria-hidden="true">
    <span class="ocr-doc-dot"></span>
    <span class="ocr-scanline"></span>
  </div>
  @if (kestaaPitkaan()) {
    <h3 class="ocr-title">{{ 'tositteet.lisaa-tositteita.ocr-luenta.kestaa-otsikko' | translate | async }}<span class="dots"></span></h3>
    <p class="ocr-sub">{{ 'tositteet.lisaa-tositteita.ocr-luenta.kestaa-selite' | translate | async }}</p>
  } @else {
    <h3 class="ocr-title">{{ 'tositteet.lisaa-tositteita.ocr-luenta.otsikko' | translate | async }}<span class="dots"></span></h3>
    <p class="ocr-sub">{{ 'tositteet.lisaa-tositteita.ocr-luenta.selite' | translate | async }}</p>
  }
  <button type="button" class="ocr-cancel" (click)="keskeyta.emit()" [attr.aria-label]="'tositteet.lisaa-tositteita.ocr-luenta.keskeyta-aria' | translate | async">
    {{ 'tositteet.lisaa-tositteita.ocr-luenta.keskeyta' | translate | async }}
  </button>
</div>
